import { ApolloAdapterConfigInput } from '@autonomous-testing/sdk';

/*
Extends the SDK's *input* config rather than its parsed one. Every SDK option
that has a default is required on the parsed type, so extending that would make
each new defaulted SDK option a breaking change here.
*/
export interface ScreenshotValidationOptions extends ApolloAdapterConfigInput {
  /*
  If true, screenshotValidation is enabled.
  */
  screenshotValidationEnabled?: boolean;
  /*
  If true, will be collected through trackFullPage and trackViewport methods if screenshotValidationEnabled is also true.
  */
  collectPageContent?: boolean;
}

export interface WopeeOptions {
  screenshotValidation?: ScreenshotValidationOptions;
}
